import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Leaf } from 'lucide-react';
import l from "../assets/sde.svg";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-[9998] transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg py-2' : 'bg-white/95 backdrop-blur-sm py-4'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img
              src={l}
              alt="Shri Durga Enterprises"
              className="h-12 w-12 object-contain transition-transform duration-300 group-hover:scale-110"
            />
            <div>
              <h1 className="text-lg font-bold text-[#004534] leading-tight">
                Shri Durga Enterprises
              </h1>
              <p className="text-xs text-[#0C6951]">Solar Solutions</p>
            </div>
          </Link>

          {/* CO2 Savings Badge - Desktop */}
          <div className="hidden lg:flex items-center space-x-2 bg-gradient-to-r from-green-50 to-blue-50 px-4 py-2 rounded-full border border-green-200">
            <Leaf className="w-5 h-5 text-green-600 animate-pulse" />
            <div className="text-sm">
              <span className="font-bold text-green-700">2,75000/- Tons</span>
              <span className="text-gray-600 ml-1">CO₂ Saved Annually</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                  location.pathname === link.path
                    ? 'bg-[#22c55e] text-white shadow-md'
                    : 'text-[#004534] hover:bg-green-50 hover:text-[#0C6951]'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg bg-[#22c55e] text-white hover:bg-[#16a34a] transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 animate-slideDown">
            {/* CO2 Badge Mobile */}
            <div className="flex items-center justify-center space-x-2 bg-gradient-to-r from-green-50 to-blue-50 px-4 py-3 rounded-lg border border-green-200 mb-4">
              <Leaf className="w-5 h-5 text-green-600" />
              <div className="text-sm">
                <span className="font-bold text-green-700">50,000 Tons</span>
                <span className="text-gray-600 ml-1">CO₂ Saved</span>
              </div>
            </div>

            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-all duration-300 mb-2 ${
                  location.pathname === link.path
                    ? 'bg-[#22c55e] text-white'
                    : 'text-[#004534] hover:bg-green-50'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        )}
      </div>

      <style jsx>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slideDown {
          animation: slideDown 0.3s ease-out;
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
